<script lang="ts">
  interface Props {
    className?: string
  }

  let { className = 'h-5 w-5' }: Props = $props()
</script>

<svg class={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g stroke="currentColor" stroke-width="2" fill="none">
    <rect x="3" y="3" width="4" height="4" rx="1" />
    <rect x="3" y="17" width="4" height="4" rx="1" />
    <rect x="17" y="3" width="4" height="4" rx="1" />
    <rect x="17" y="17" width="4" height="4" rx="1" />
  </g>
  <rect x="4" y="8" width="2" height="8" fill="currentColor" />
  <rect x="8" y="20" width="2" height="8" transform="rotate(-90 8 20)" fill="currentColor" />
  <rect x="18" y="8" width="2" height="8" fill="currentColor" />
  <rect x="8" y="6" width="2" height="8" transform="rotate(-90 8 6)" fill="currentColor" />
</svg>
